import {MovingSectionView} from '../../ui_canvas_engine/MovingSectionView'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {PIXI} from '@colonist/pixi'
import {NotificationCounterView} from '../../ui_canvas_engine/NotificationCounterView'

export class UIGameSpriteWithNotificationView extends MovingSectionView {
    readonly spriteView: SpriteView
    counter: NotificationCounterView

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, texture: PIXI.Texture) {
        super(x, y, w, h, container)

        this.spriteView = new SpriteView(0, 0, this.width, this.height, this, texture)

        const counterSize = this.width * 0.48
        const counterX = this.width * 0.55
        const counterY = this.height * 0.6
        this.counter = new NotificationCounterView(counterX, counterY, counterSize, counterSize, this)
    }
}
